import api from '@/services/api'

const controlAcceso = {
  // Catalogo (lectura desde portal cliente para construir matrices)
  listarModulos: () => api.get('/control-acceso/cliente/modulos').then(r => r.data),

  // Roles por empresa
  listarRoles:        ()             => api.get('/control-acceso/roles').then(r => r.data),
  obtenerRol:         (id)           => api.get(`/control-acceso/roles/${id}`).then(r => r.data),
  crearRol:           (data)         => api.post('/control-acceso/roles', data).then(r => r.data),
  actualizarRol:      (id, data)     => api.put(`/control-acceso/roles/${id}`, data).then(r => r.data),
  eliminarRol:        (id)           => api.delete(`/control-acceso/roles/${id}`).then(r => r.data),
  setPermisosRol:     (id, permisos) => api.put(`/control-acceso/roles/${id}/permisos`, { permisos }).then(r => r.data),

  // Usuarios cliente
  listarUsuarios:     ()             => api.get('/control-acceso/usuarios').then(r => r.data),
  limitesUsuarios:    ()             => api.get('/control-acceso/limites-usuarios').then(r => r.data),
  permisosUsuario:    (uid)          => api.get(`/control-acceso/usuarios/${uid}/permisos`).then(r => r.data),
  setRolesUsuario:    (uid, rolIds)  => api.put(`/control-acceso/usuarios/${uid}/roles`, { rol_ids: rolIds }).then(r => r.data),

  // Permisos efectivos del usuario autenticado
  misPermisos: () => api.get('/control-acceso/mis-permisos').then(r => r.data),
}

export default controlAcceso
